import getRules from './getRules'
import saveRuleClient from './saveRuleClient'
import getMonitorTipoReglas from './getMonitorTipoReglas'
import saveMonitorTipoReglas from './saveMonitorTipoReglas'
import getMonitorRegistros from './getMonitorRegistros'
import getMonitorRegistro from './getMonitorRegistro'
import saveRegistro from './saveRegistro'
import getAlertasByRegistro from './getAlertasByRegistro'
import getMonitorHistorialRegla from './getMonitorHistorialRegla'
import deleteSimulacion from './deleteSimulacion'
import aplicarSimulacion from './aplicarSimulacion'
import getIndicatorsRules from './getIndicatorsRules'
import getIndicatorsRangeAlerts from './getIndicatorsRangeAlerts'
import getIndicatorsRisks from './getIndicatorsRisks'
import getIndicatorsRisksStatus from './getIndicatorsRisksStatus'
import getCategoriesClient from './getCategoriesClient'
import getResumeAlerts from "./getResumeAlerts";
import getItems from "./getItems"
import getResumeAlertsByCategory from './getResumeAlertsByCategory'
import getValoresParametroCliente from './getValoresParametroCliente'
import uploadValoresParamRule from './uploadValoresParamRule'

export const getRulesPromise = getRules
export const saveRuleClientPromise = saveRuleClient
export const getMonitorTipoReglasPromise = getMonitorTipoReglas
export const saveMonitorTipoReglasPromise = saveMonitorTipoReglas
export const getMonitorRegistrosPromise = getMonitorRegistros
export const getMonitorRegistroPromise = getMonitorRegistro
export const saveRegistroPromise = saveRegistro
export const getAlertasByRegistroPromise = getAlertasByRegistro
export const getMonitorHistorialReglaPromise = getMonitorHistorialRegla
export const deleteSimulacionPromise = deleteSimulacion
export const aplicarSimulacionPromise = aplicarSimulacion
export const getIndicatorsRulesPromise = getIndicatorsRules
export const getIndicatorsRangeAlertsPromise = getIndicatorsRangeAlerts
export const getIndicatorsRisksPromise = getIndicatorsRisks
export const getIndicatorsRisksStatusPromise = getIndicatorsRisksStatus
export const getCategoriesClientPromise = getCategoriesClient
export const getResumeAlertsPromise = getResumeAlerts
export const getResumeAlertsByCategoryPromise = getResumeAlertsByCategory
export const getItemsPromise = getItems
export const getValoresParametroClientePromise = getValoresParametroCliente
export const uploadValoresParamRulePromise = uploadValoresParamRule
